import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable ,  of } from 'rxjs';
// import { FakeRechargeHistoryList } from './fake-recharge-history';
import { ApiUrlHelper } from '../api-url-helper';
import { RechargeRecordformer } from '../../_transformers/recharge-record.transformer';
import { HttpClientHelper } from '../http-helper';
import { map, shareReplay } from 'rxjs/operators';
// import { environment } from '../../../environments/environment';
import { StorageService } from 'app/storageprovider';
@Injectable({
    providedIn:"root"
})
export class RechargeService {
    regionCode = 'GL';
    lastRegion = null;
    constructor(
        private _apiUrlHelper: ApiUrlHelper,
        private _rechargeRecordformer: RechargeRecordformer,
        private _httpClientHelper: HttpClientHelper,
        private _storage: StorageService,
    ) { }

    getRechargeHistory(user, page, pageSize): Observable<any> {
        const apiURL = this._apiUrlHelper.urlBuilder('recharge-history', {
            page: page,
            pageSize: pageSize,
            // uid: user.id,
            // gid: user.token.gid,
            // expire: user.token.expire,
            // sign: user.token.sign,
            // token: user.token.token,
        });
        return this._httpClientHelper.get(apiURL)
        .pipe(map((res: Response) => {
                try {
                    return {
                        count: res[0].count,
                        items: res[0].list.map(item => {
                            return this._rechargeRecordformer.transform(item);
                        })
                    };
                } catch {
                    return res[0];
                }
            }));
    }

    // getCustomerServiceInfo() {
    //     try{
    //         this.regionCode = this._storage.GetConfig()['region']? this._storage.GetConfig()['region'].split('.')[0]:"";
    //     }
    //     catch(err)
    //     {

    //     }
    //     const csApi = this._apiUrlHelper.urlBuilder('customer-service-info',{type: 1, region: this.regionCode});
    //     return this._httpClientHelper.get(csApi, true);
    // }

    getCustomerServiceInfoChat(type) {
        try{
            this.regionCode = this._storage.GetConfig()['region']? this._storage.GetConfig()['region'].split('.')[0]:"";
        }
        catch(err)
        {

        }
        const api = this._apiUrlHelper.urlBuilder('customer-service-info-chat',{type: type, region: this.regionCode});
        return this._httpClientHelper.getWithCache(api);
    }

    private sharedProduct:Observable<any> = null;
    private lastUID = 0;
    private productState:BehaviorSubject<DataState> = new BehaviorSubject<DataState>({
        hasValue : false,
        state:null
    });
    public productState$ = this.productState.asObservable();
    clearState()
    {
        this.sharedProduct = null;
        this.lastUID = 0;
    }
    changeProductState(state:any)
    {
        this.productState.next({
            hasValue:true,
            state:state
        })
    }
    getProductsAndPayment(): Observable<any> {
        if (this.lastRegion !== this.regionCode) {
            this.lastRegion = this.regionCode;
            this.sharedProduct = null; 
        }
        if(this.sharedProduct !=null 
            && this._httpClientHelper.token?.uid == this.lastUID)
        {
            return this.sharedProduct;
        }
        this.lastUID = this._httpClientHelper.token?.uid;
        var apiURL = this._apiUrlHelper.urlBuilder('products', {
            region: this.regionCode,
        });
        this.sharedProduct = this._httpClientHelper.get(apiURL, false)
        .pipe(map((res: Response) => {
                return {
                    products: this.sortProducts(res[0]['options'].productlist.map(
                        item => {
                            return this.transformProduct(item);
                        }
                    )),
                    products_region:this.sortProducts(res[0]['options'].productlist_region.map(
                        item => {
                            return this.transformProduct(item);
                        }
                    )),
                    products_original: !!res[0]['options'].product_original ? this.sortProducts(res[0]['options'].product_original.map(
                        item => {
                            return this.transformProduct(item);
                        }
                    )) : [],
                    payments: res[0]['options'].paymentlist,
                    discountInfo:res[0]['discountInfo'],
                    isbindtelphone: res[0]['options'].isbindtelphone,
                    tabs: res[0].tabs,
                    currency: res[0].currency,
                    shareSale: !!res[0].shareSale ? res[0].shareSale : '',
                    shareTxt: !!res[0].shareTxt ? res[0].shareTxt : '',
                };
            }))
            .pipe(shareReplay({
                bufferSize:1,
                refCount:true
              }))
            
            return this.sharedProduct;
    }

    transformProduct(product) {
        product.value = product.productName;
        var minusPrice = 0;
        var discount = 1.0;

        for(var i=0;i<product.promotions.length;++i)
        {
            if(product.promotions[i].minusPrice>0)
            minusPrice+= product.promotions[i].minusPrice;
            if(product.promotions[i].discountRate>0)
            discount =product.promotions[i].discountRate / 100 *discount;
        }
        if(discount<=0)
        {
            discount= 1.0;
        }
        product.productCNYOG = product.memo;
        product.productValueOG = product.productValue;
        product.productValue = product.productValue * discount - minusPrice;
        //if(product.promotions.length)
        switch (product.productID) {
            case 111:
            case 1: {
          
                product.label = '<span class="orange">黄金</span>VIP';
                product.group = 1;
                break;
            }
            case 112:
            case 2: {
        
                product.label = '<span class="orange">黄金</span>VIP';
                product.group = 2;
                break;
            }
            case 113:
            case 3: {
           
                product.label = '<span class="red">至尊</span>VIP';
                product.group = 3;
                break;
            }
            case 114:
            case 4: {
                product.label = '<span class="rose">情侣</span>VIP';
                product.mutupleDevice = true;
                product.group =4;

                break;
            }
        }
        product.label = product.customHtml || product.label;
        product.prompt = product.isPromot;

        return product;

    }

    sortProducts(products) {
        return products.sort(function (a, b) {
            return a.order - b.order;
        });
    }
}


export class DataState
{
    public hasValue:boolean;
    public state:any;
}